export const TariffSymbols = {
    TariffService: Symbol.for("TariffService"),
    TariffServiceCached: Symbol.for("TariffServiceCached"),
    TariffProvider: Symbol.for("TariffProvider"),
    TariffCapacityService: Symbol.for("TariffCapacityService"),
    TariffCapacityServiceCached: Symbol.for("TariffCapacityServiceCached"),
    TariffCapacityProvider: Symbol.for("TariffCapacityProvider")
}